{
  "FormEngineRedirectWfl": {
    "title": "Umleiten",
    "description": "Reagieren Sie auf Ereignisse, indem Sie auf eine Webseite umleiten"
  },
  "mask": {
    "FormEngineRedirectWfl": {
      "description": "Beschreibung",
      "url": "URL",
      "urlTarget": "URL-Ziel",
      "allowForeignOrigins": "Erlaube Fremd-Domänen"
    }
  }
}